import clsx from "clsx";
import { ChangeEventHandler } from "react";
import classes from "./BaseInput.module.scss";

type PropsType = {
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  label?: string;
  className?: string;
  style?: React.CSSProperties;
};

const BaseInput = (props: PropsType) => {
  const { label, value, onChange, className, style } = props;

  return (
    <div className={clsx(classes["base-input__div"], className)} style={style}>
      <input className={classes["base-input__input"]} value={value} onChange={onChange} />
      <label className={clsx(classes["base-input__label"], { [classes.filled]: value })}>{label}</label>
    </div>
  );
};

export default BaseInput;
